import React from 'react';
import { useTranslation } from 'react-i18next';
import { HashLink as Link } from 'react-router-hash-link';

const Footer = () => {

  const { t, i18n } = useTranslation();

  return (
    <footer>

      <div id={"footer_wrapper"}>

        <div id={"footer_menu"}>
          <nav>
            <Link to={"/contact"}>{t("footer_contact")}</Link>
            <Link to={"/faq"}>{t("footer_faq")}</Link>
            <a href={"/file/Règlement.pdf"} target={"_blank"}>{t("footer_reglement")}</a>
            <a href={"/file/Politique%20de%20cookies.pdf"} target={"_blank"}>{t("footer_politique_cookies")}</a>
            <a href={"https://www.casinosbarriere.com/politique-de-confidentialite"} target={"_blank"}>{t("footer_politique_confidentialite")}</a>
            <Link to={"/informations-legales"}>{t("footer_informations_legales")}</Link>
          </nav>
        </div>

        <div className={"footer_logo_wrapper"}>
          <div className={"footer_logo"}>
            <a id={"footer_logo_partenaire"} href={"https://www.casinosbarriere.com/"} target={"_blank"} />
            <a id={"footer_logo_instagram"} href={"https://www.instagram.com/casinos.barriere/"} target={"_blank"} data-lang={i18n.language} />
            <a id={"footer_logo_tlc"} href={"https://www.tlcmarketing.com/france"} target={"_blank"} />
          </div>
        </div>
      </div>
      <div id={"footer_mention"}>
        <a href={"https://www.casinosbarriere.com/jeu-responsable"} target={"_blank"}>
          <div>
            <img src={"/images/mobile/age.png"} />
          </div>
          <div>
            <p dangerouslySetInnerHTML={{ __html: t("footer_paragraph1") }} />
            <p dangerouslySetInnerHTML={{ __html: t("footer_paragraph2") }} />
          </div>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
